export default __webpack_public_path__ + "static/media/pockets-by-pros.01bb81f3.jpg";